import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ImpactForecastingGraph = ({ dataSource }) => {
  const [impactForecastingData, setImpactForecastingData] = useState([]);

  useEffect(() => {
    if (dataSource) {
      setImpactForecastingData(dataSource);
    }
  }, [dataSource]);

  const chartOptions = {
    chart: {
      type: "line",
    },
    title: {
      text: "Impact Forecasting Graph",
    },
    xAxis: {
      categories: impactForecastingData.map((item) => item.date),
      title: {
        text: "Quarters",
      },
    },
    yAxis: {
      title: {
        text: "Savings ($)",
      },
      labels: {
        format: "${value}",
      },
    },
    tooltip: {
      pointFormat: "<b>{series.name}</b>: ${point.y}",
    },
    series: [
      {
        name: "Potential Savings",
        data: impactForecastingData.map((item) => item.potential_savings),
      },
      {
        name: "Actual Savings",
        data: impactForecastingData.map((item) => item.actual_savings),
      },
      {
        name: "Variance",
        data: impactForecastingData.map((item) => item.variance),
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default ImpactForecastingGraph;
